module.exports = __webpack_public_path__ + "img/picture_member_jitsuryoku_screenshot.bb341b5f.png";